import React from 'react';
// import axios from '../../api/axios';
// import { BrowserRouter, Routes, Route, Link, useNavigate } from 'react-router-dom';

const Contact = () => {
 

    return (
        <div className="p-4">
            <h1 className="text-2xl font-bold mb-4">Contact Us</h1>
   
        </div>
    );
}

export default Contact;
